// extracted by mini-css-extract-plugin
module.exports = {"Consent":"Consent_Consent__RsTbr","Accept":"Consent_Accept__2BvLY"};